import React from 'react';

export const StopAudioIcon = props => (
    <svg width="17" height="30" viewBox="0 0 17 30">
        <g fill={props.color} fillRule="nonzero">
            <path d="M2.844 29.79a2.66 2.66 0 0 1-2.66-2.66V2.87a2.66 2.66 0 1 1 5.32 0v24.26a2.66 2.66 0 0 1-2.66 2.66zM13.9 29.79a2.66 2.66 0 0 1-2.66-2.66V2.87a2.66 2.66 0 1 1 5.32 0v24.26a2.66 2.66 0 0 1-2.66 2.66z" />
        </g>
    </svg>
);
